<template>
  <div class="card project-card h-100">
    <!-- Image -->
    <img
        :src="project.image"
        class="card-img-top"
        alt="Projet CNTIPPEE"
    />

    <div class="card-body d-flex flex-column">
      <!-- Axe -->
      <span class="badge bg-primary mb-2 align-self-start">
        {{ project.axis }}
      </span>

      <!-- Titre -->
      <h5 class="card-title fw-bold">
        {{ project.title }}
      </h5>

      <!-- Province -->
      <p class="text-muted mb-1">
        📍 {{ project.province }}
      </p>

      <!-- Description -->
      <p class="card-text text-muted small mb-3">
        {{ project.description }}
      </p>

      <!-- Progression -->
      <div class="mt-auto">
        <div class="progress mb-2">
          <div
              class="progress-bar"
              :class="progressClass"
              role="progressbar"
              :style="{ width: project.progress + '%' }"
              :aria-valuenow="project.progress"
              aria-valuemin="0"
              aria-valuemax="100"
          >
            {{ project.progress }}%
          </div>
        </div>

        <!-- Statut -->
        <small class="text-muted d-flex justify-content-between align-items-center">
          <span>
            Statut :
            <strong>{{ formatStatus(project.status) }}</strong>
          </span>

          <span v-if="project.timeline?.length">
            🕒 {{ project.timeline.length }} étapes
          </span>
        </small>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'ProjectCard',
    props: {
      project: {
        type: Object,
        required: true
      }
    },
    computed: {
      progressClass() {
        if (this.project.progress === 100) return 'bg-success'
        if (this.project.progress >= 50) return 'bg-info'
        return 'bg-warning'
      }
    },
    methods: {
      formatStatus(status) {
        switch (status) {
          case 'EN_COURS':
            return 'En cours'
          case 'TERMINE':
            return 'Terminé'
          case 'EN_PREPARATION':
            return 'En préparation'
          default:
            return status
        }
      }
    }
  }

</script>

<style scoped>
.project-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.project-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.card-img-top {
  height: 180px;
  object-fit: cover;
}
</style>

